import type { ReactNode } from 'react';
import React from 'react';

import { cx } from '@travel/utils';

import styles from './layout.module.scss';

type Props = {
  className?: string;
  /** Node of children component */
  children: ReactNode;
};

function Layout(props: Props) {
  const { className, children, ...rest } = props;

  return (
    <div className={cx(styles.wrapper, className)} {...rest}>
      {children}
    </div>
  );
}

export default Layout;
